export default routesModules;

/** @ngInject */
function routesModules($stateProvider) {
  $stateProvider
    .state('modules', {
      abstract: true,
      parent: 'layout'
    });
}
